
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"}},_vm.$listeners),[_c('path',{attrs:{"d":"M7.416 13H2.5a1.5 1.5 0 1 1 0-3h4.916a2.976 2.976 0 0 1 5.168 0h.916a1.5 1.5 0 1 1 0 3h-.916a2.976 2.976 0 0 1-5.168 0ZM8.5 11.5A1.5 1.5 0 1 0 10 10a1.5 1.5 0 0 0-1.5 1.5ZM3.416 6H2.5a1.5 1.5 0 1 1 0-3h.915a2.976 2.976 0 0 1 5.169 0H13.5a1.5 1.5 0 1 1 0 3H8.584a2.976 2.976 0 0 1-5.169 0ZM4.5 4.5A1.5 1.5 0 1 0 6 3a1.5 1.5 0 0 0-1.5 1.5Z"}})])}
var staticRenderFns = []

    export default {
      render: render,
    }
  